export default __webpack_public_path__ + "static/media/background.8c84d5e7.png";